export const BREADCRUMB_JOINED_SEPARATOR = '  ›  ';
